export default "__VITE_ASSET__BUAUD0PQ__"